/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

import { codeOk, errorMessage } from "../../lib/index";
import { useUserContext } from "../../context/UserContext";

import {
  InputField,
  PhoneInput,
  MyMessage,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { FiUser, FiLock, FiPhone } from "react-icons/fi";

const Add = () => {
  const { createOneUser } = useUserContext();

  const [error, setError] = useState(false);
  const [, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState<any>(0);
  const [phone, setPhone] = useState<any>(0);
  const [password, setPassword] = useState<any>(0);

  const userRoutes = "/user";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);

    setFirstName(null);
    setLastName(null);
    setEmail(null);
    setPhone(null);
    setPassword(null);
  };

  const responses = (isError: any, _status: any, _message: any) => {
    setError(isError);
    setStatus(_status);
    setErrorMessage(_message);
  };

  const addOneTourPackageHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    if (!firstName || firstName === "") {
      responses(true, 400, "First Name is required");
      setLoading(false);
    } else if (!lastName || lastName === "") {
      responses(true, 400, "Last Name is required");
      setLoading(false);
    } else if (!email || email === "") {
      responses(true, 400, "Email is required");
      setLoading(false);
    } else if (!phone || phone === "") {
      responses(true, 400, "Phone is required");
      setLoading(false);
    } else if (!password || password === "") {
      responses(true, 400, "Password is required");
      setLoading(false);
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: phone,
      password: password,
    };

    const response = await createOneUser(data);
    if (response) {
      if (response.data.status === codeOk) {
        cleanFields();
        return responses(false, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={userRoutes}
      eyebrow="Team • Users"
      title="Add User"
      subtitle="Create a new user account with identity, contact and a starting password."
      icon={<FiUser className="h-5 w-5" />}
      size="md"
      loading={loading}
      submitLabel="Add User"
      onSubmit={addOneTourPackageHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Identity"
        hint="Names appear in mentions and access logs."
        icon={<FiUser className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "first_name",
              title: "First Name",
              type: "text",
              required: true,
              value: firstName ? firstName : "",
              onChange: (e: any) => {
                setFirstName(e.target.value);
                setError(false);
                setSuccess(false);
              },
            }}
          />
          <InputField
            props={{
              id: "last_name",
              title: "Last Name",
              type: "text",
              required: true,
              value: lastName ? lastName : "",
              onChange: (e: any) => {
                setLastName(e.target.value);
                setError(false);
                setSuccess(false);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Contact"
        hint="Used to sign in and to receive notifications."
        icon={<FiPhone className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "email",
              title: "Email Address",
              type: "email",
              required: true,
              value: email ? email : "",
              onChange: (e: any) => {
                setEmail(e.target.value);
                setError(false);
                setSuccess(false);
              },
            }}
          />
          <PhoneInput setPhone={setPhone} phone={phone} required={true} />
        </div>
      </AddSection>

      <AddSection
        title="Initial Password"
        hint="Share securely. Users will be prompted to change it."
        icon={<FiLock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "password",
              title: "Password",
              type: "password",
              required: true,
              value: password ? password : "",
              onChange: (e: any) => {
                setPassword(e.target.value);
                setError(false);
                setSuccess(false);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
